var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalloon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73409 11.3751C2.77128 11.2382 2.68909 11.0479 2.61066 10.9107C2.58623 10.8698 2.55974 10.8302 2.53128 10.792C1.85855 9.77177 1.49999 8.57656 1.50003 7.3545C1.48909 3.84668 4.39784 1.00012 7.99472 1.00012C11.1316 1.00012 13.75 3.17325 14.3619 6.05793C14.4536 6.48562 14.4999 6.92178 14.5 7.35918C14.5 10.872 11.7035 13.7632 8.10659 13.7632C7.53472 13.7632 6.76284 13.6195 6.34191 13.5017C5.92097 13.3839 5.50066 13.2276 5.39222 13.1857C5.28131 13.1431 5.16353 13.1212 5.04472 13.1211C4.91494 13.1206 4.78641 13.1464 4.66691 13.197L2.54722 13.962C2.50078 13.982 2.45157 13.9949 2.40128 14.0001C2.36159 14 2.32232 13.992 2.28574 13.9766C2.24917 13.9612 2.21601 13.9387 2.18819 13.9104C2.16038 13.8821 2.13846 13.8485 2.1237 13.8117C2.10894 13.7748 2.10164 13.7354 2.10222 13.6957C2.10483 13.6609 2.11111 13.6264 2.12097 13.5929L2.73409 11.3751Z",
    stroke: "#C2CFE0",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloon);
export default __webpack_public_path__ + "static/media/Balloon.2e67e8b4.svg";
export { ForwardRef as ReactComponent };